import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { resetDialogMessage } from '../../../store/states/DialogSlice';
import {
  getMarketAssociation,
  deleteMarketAssociation,
  getMarketDetails,
  updateMarketAssociation,
} from '../../../store/states/MarketSlice';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { EActionType, EDataTableType, MarketAssocaiationFormFields } from '../../../data/Constants';
import { GenericSimpleForm } from '../../Layouts/GenericSimpleForm';
import { TFunction } from 'i18next';

import type {
  IAPIResponse,
  ILanguage,
  IMarketFormData,
  IMarketsPropsData,
} from '../../../../types';

const handleUpdate = (
  res: IAPIResponse,
  props: {
    data: {
      page: number;
      recordsPerPage: number;
      searchValue: string;
    };
  },
  t: TFunction,
  dispatch: AppDispatch
) => {
  if (res?.data) {
    dispatch(
      getMarketAssociation({
        page: props.data.page,
        limit: props.data.recordsPerPage,
        searchCode: props.data.searchValue,
      })
    );
    dispatch(
      setAlertMessage({ show: true, message: t('messages.success.update'), type: 'success' })
    );
    dispatch(resetDialogMessage());
  } else {
    const message = res?.error?.message ? res.error.message : t('messages.fail.update');
    dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
  }
};

export const MarketAssociationManipulationForm = (props: IMarketsPropsData) => {
  const { t } = useTranslation();
  const [marketsAvailable, setMarketsAvailable] = useState<ILanguage[]>([]);
  const [initialFormData, setInitialFormData] = useState<IMarketFormData>({
    productCode: '',
    markets: [],
  });

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getMarketDetails({ request: [] })).then((response: any) => {
      setMarketsAvailable(response.payload.data);
      const activeMarkets = response.payload.data.filter((obj: ILanguage) => obj.isActive);
      MarketAssocaiationFormFields.filter((app) => app.field == 'markets')?.map(
        (app) => (app.values = activeMarkets)
      );
    });
    setInitialFormData({
      productCode: props.data.productCode,
      markets: props.data.markets.map((p) => p.code).sort((a, b) => a.localeCompare(b)),
    });
  }, []);

  useEffect(() => {
    const activeMarkets = marketsAvailable.filter((obj) => obj.isActive);
    MarketAssocaiationFormFields.filter((app) => app.field == 'markets')?.map(
      (app) => (app.values = activeMarkets)
    );
  }, [marketsAvailable]);

  const handleSubmit = (data: IMarketFormData) => {
    const addMark: string[] = [];
    const delMark: string[] = [];
    //find which is present in initial but not in current those are deleted
    //find which is present in current but not in inital those are added

    initialFormData.markets.forEach((element) => {
      if (!data.markets.includes(element)) {
        delMark.push(element);
      }
    });

    data.markets.forEach((element) => {
      if (!initialFormData.markets.includes(element)) {
        addMark.push(element);
      }
    });

    if (addMark.length > 0) {
      dispatch(updateMarketAssociation({ request: { ...data, markets: addMark } })).then((res) => {
        handleUpdate(res.payload as IAPIResponse, props, t, dispatch);
      });
    }

    if (delMark.length > 0) {
      dispatch(deleteMarketAssociation({ request: { ...data, markets: delMark } })).then((res) => {
        handleUpdate(res.payload as IAPIResponse, props, t, dispatch);
      });
    }
  };

  return (
    <Box className="manipulationBox">
      <Box className="manipulationForm">
        <GenericSimpleForm
          formFields={MarketAssocaiationFormFields}
          initialData={initialFormData}
          onSubmit={handleSubmit}
          manipulationType={EActionType.Edit}
          type={EDataTableType.MarketAssociation}
          uniqueKey="productCode"
        />
      </Box>
    </Box>
  );
};
